
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warrantyExtensions",
      function () {
        return require("private-next-pages/warrantyExtensions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warrantyExtensions"])
      });
    }
  